import { defaultTheme } from '../../../theme'
import React from 'react'

export const ProgressCircle: React.FC<{ radius?: number; stroke?: number; percent: number }> = ({
  radius = 30,
  stroke = 6,
  percent,
}) => {
  const normalizedRadius = radius - stroke * 2
  const circumference = normalizedRadius * 2 * Math.PI
  const strokeDashoffset = circumference - (percent / 100) * circumference
  return (
    <svg height={radius * 2} width={radius * 2}>
      <circle
        stroke={defaultTheme.color.primary600}
        fill="transparent"
        strokeWidth={stroke}
        strokeDasharray={circumference + ' ' + circumference}
        style={{ strokeDashoffset }}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
    </svg>
  )
}
